<template>
    <div id="modal-template">
        <transition name="modal">
            <div class="modal-mask" @click="close" v-show="show">
                <div class="modal-container">
                    <span @click.stop>
                        <slot name="body" class="modal-body"></slot>
                    </span>
                    <slot name="footer" class="modal-footer"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
  export default {
    props: ['show'],
    methods: {
      close() {
        this.$emit('close');
      },
      save() {
        this.close();
      }
    }
  }
</script>
